import { defineModule } from '@/core/define';
import { overridable } from '@/core/template-engine';

export default defineModule({
    id: 'profile',
    routes: [
        {
            path: '/profile',
            name: 'profile',
            meta: { requiresAuth: true },
            component: overridable('ProfilePage', () => import(/* webpackChunkName: "profile" */ './views/ProfilePage.vue'))
        }
    ],
    contributes: {
        'sidebar.menu': [
            { key: 'member', order: 30, icon: 'images/menu/member.png', to: '/profile', mobileHidden: true }
        ],
        'bottom.nav': [
            { key: 'member', order: 40, icon: 'images/icons/nav-member.png', to: '/profile', loginFirst: true }
        ],
        'nav.menu': [
            { key: 'profile', order: 40, label: 'nav.profile', to: '/profile' }
        ]
    }
});
